import React from "react"

export default props => (
  <div className="">
    <h1 className="title is-6 has-text-grey">
      Download Spark Camera for free on the App Store
    </h1>

    <a
      href="https://apps.apple.com/app/apple-store/id1133670954?pt=118946101&ct=learn&mt=8"
      style={{
        display: "inline-block",
        overflow: "hidden",
        backgroundImage:
          "url(https://linkmaker.itunes.apple.com/en-us/badge-lrg.svg?releaseDate=2016-08-18&kind=iossoftware&bubble=ios_apps)",
        noRepeat: true,
        width: "135px",
        height: "40px",
      }}
    ></a>

    {/* <div className="columns is-mobile">
      <div className="column has-text-centered is-2">
        <img
          className="video-thumb"
          src="https://images.unsplash.com/photo-1490359144708-3329fae5c6e8?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1347&q=80"
        ></img>
        <p>Voiceovers</p>
      </div>
      <div className="column has-text-centered is-2">
        <img
          className="video-thumb"
          src="https://images.unsplash.com/photo-1534543210152-32025bcfaad9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60"
        ></img>
        <p>Volume</p>
      </div>
      <div className="column has-text-centered is-2">
        <img
          className="video-thumb"
          src="https://images.unsplash.com/photo-1459533366051-65646610382c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"
        ></img>
        <p>Filters</p>
      </div>
      <div className="column has-text-centered is-2">
        <img
          className="video-thumb"
          src="https://images.unsplash.com/photo-1506079478915-3f458c5077a7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80"
        ></img>
        <p>Imports</p>
      </div>
    </div> */}
  </div>
)
